export default {
  sidebar: localStorage.getItem('caisse-sidebar'),
  autoPrint: localStorage.getItem('auto-print'),
  nextoreProducts: []
}
